<template>
    <div class="content-wrapper">
        <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
                            <li class="breadcrumb-item page-header d-flex align-items-center">
                                <h4 class="mb-0">{{ $t('pollQuestions.poll_question_details') }}</h4>
                            </li>
                            <template v-if="this.$can('view_poll_questions')">
                                <li class="ml-2">|</li>
                                <li>
                                    <a :href="urlGenerator(pollQuestionWebUrl)"
                                       class="btn btn-link text-primary pl-2">{{
                                            $t('pollQuestions.back_to_all_poll_question')
                                        }}</a>
                                </li>
                            </template>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="d-flex justify-content-lg-end mb-primary">
                    <div class="dropdown">
                        <button type="button"
                                class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                            {{ $t('action') }}
                            <app-icon name="chevron-down"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item" @click="editPollQuestion">
                                {{ $t('edit') }}
                            </a>

                            <a href="#" class="dropdown-item" @click.prevent="deletePollQuestion">
                                {{ $t('delete') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="poll-question-profile mb-primary">
            <div class="card card-with-shadow py-5 border-0" style="min-height: 220px;">
                <app-overlay-loader v-if="loader"/>
                <div v-else class="row">
                    <!-- Left Section -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 poll-question-header-media align-items-center">
                            <div class="media-body poll-question-info-header">
                                <p class="text-muted mb-0">{{ $t('pollQuestions.question_text') }}</p>
                                <p>{{ pollQuestion.question_text }}</p>
                            </div>
                        </div>

                        <div class="media border-right px-5 poll-question-header-media align-items-center">
                            <div class="media-body poll-question-info-header">
                                <p class="text-muted mb-0 mt-2">{{ $t('pollQuestions.question_type') }}</p>
                                <p>{{ pollQuestion.question_type }}</p>
                            </div>
                        </div>
                        <div class="media border-right px-5 poll-header-media align-items-center">
                            <div class="media-body poll-info-header">
                                <p class="text-muted mb-0 mt-2">{{ $t('poll') }}</p>
                                <p v-if="pollQuestion.poll" >
                                    {{ pollQuestion.poll.title }}
                                </p>
                                <p v-else>{{ $t('not_added_yet') }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Right Section -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div
                            class="poll-question-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <!-- Left Column of Details -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="user"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('created_by') }}</p>
                                                <p v-if="pollQuestion.created_by">{{ pollQuestion.creator.full_name }}</p>
                                                <p v-else>{{ $t('not_added_yet') }}</p>
                                            </div>
                                        </div>

                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('created_at') }}</p>
                                                <p>{{ formattedDate(pollQuestion.created_at) }}</p>
                                            </div>
                                        </div>

                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('updated_at') }}</p>
                                                <p>{{ formattedDate(pollQuestion.updated_at) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-poll-question-modal
            v-if="isPollQuestionModalActive"
            v-model="isPollQuestionModalActive"
            :selected-url="updateUrl"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import {axiosDelete, urlGenerator} from '../../../../../common/Helper/AxiosHelper';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import pollQuestionCreateEditModal from "../../Pms/PollQuestion/PollQuestionCreateEditModal";
import {formatDateTimeToLocalDate, formattedDate} from "../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {POLL_QUESTION, POLL_QUESTION_WEB} from "../../../../Config/ApiUrl"; // Adjust the API URLs accordingly

export default {
    name: "pollQuestionDetails",
    mixins: [FormMixin],
    components: {pollQuestionCreateEditModal},
    props: {
        pollQuestionId: {}
    },
    data() {
        return {
            pollQuestion: {},
            pollQuestionWebUrl: POLL_QUESTION_WEB,
            urlGenerator,
            formatDateTimeToLocalDate,
            isPollQuestionModalActive: false,
            confirmationModalActive: false,
            deleteUrl: '',
            promptAction: '',
            updateUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            formattedDate
        };
    },
    mounted() {
        this.$store.dispatch("getPollQuestionDetails", this.pollQuestionId)
            .then(() => {
                if (this.pollQuestionDetails) {
                    this.pollQuestion = this.pollQuestionDetails;
                } else {
                    console.error("Poll question details not found.");
                }
            })
            .catch(error => {
                console.error("Error fetching poll details:", error);
            });
    },
    methods: {
        cancelled() {
            this.confirmationModalActive = false;
        },

        editPollQuestion() {
            this.updateUrl = `${POLL_QUESTION}/${this.pollQuestionId}`;
            this.isPollQuestionModalActive = true;
        },

        // ✅ Delete poll question functionality
        deletePollQuestion() {
            this.confirmationModalActive = true;
            this.deleteUrl = `${POLL_QUESTION}/${this.pollQuestionId}`;
            this.promptAction = 'delete_poll_question';
            this.promptTitle = this.$t('are_you_sure');
            this.promptMessage = this.$t('pollQuestion.you_are_going_to_remove_an_poll_question_from_list');
        },

        // ✅ Confirmation Modal Close
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            // ✅ Redirect using urlGenerator
            window.location.href = urlGenerator(`${POLL_QUESTION_WEB}`);
        },

        // ✅ Handles confirm button in modal
        triggerConfirm() {
            if (this.promptAction === 'delete_poll_question') {
                this.removePollQuestion(this.deleteUrl);
            }
        },

        // ✅ Delete request
        removePollQuestion(url) {
            this.loading = true;

            axiosDelete(url)
                .then(({data}) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'poll-question-table');
                })
                .catch(({response}) => {
                    this.toastException(response.data);
                    this.confirmationModalActive = false;
                })
                .finally(() => this.closeConfirmation());
        }
    },
    computed: {
        ...mapState({
            pollQuestionDetails: state => state.pollQuestion.pollQuestion,
            loader: state => state.loading,
        }),
    },
    watch: {
        pollQuestionDetails: {
            handler(newVal) {
                if (newVal) {
                    this.pollQuestion = newVal;
                }
            },
            deep: true
        }
    }
};
</script>
